class OrdersList extends HTMLElement {
  constructor() {
    super();

    this.searchOptions = {
      valueNames: [
        'address__heading',
        'address__main',
        { data: ['id', 'status'] },
        { name: 'order-summary__date--ordered', attr: 'data-date' },
        { name: 'order-summary__date--cancelled', attr: 'data-date' },
        'order-summary__fulfillment',
        'order-summary__products',
      ],
    };

    this.onLoad = this.handleLoad.bind(this);
  }

  connectedCallback() {
    window.addEventListener('load', this.onLoad);
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.onLoad);
  }

  handleLoad() {
    this.list = new window.List(this, this.searchOptions);
  }
}

customElements.define('orders-list', OrdersList);